import { type WalletLedger } from '@capsicum/common';
import { useQuery } from '@tanstack/react-query';

import { fetchNativeCurrencies } from '../api';

/**
 * @returns the native currency ledger of the user.
 */
export const useNativeCurrenciesQuery = <TData = Array<WalletLedger> | undefined>(
	select: (data: Array<WalletLedger> | undefined) => TData
) => useQuery({ queryFn: () => fetchNativeCurrencies(), queryKey: ['fetchUserNativeCurrencyLedgers'], select: select });
